import { api } from './client';

export interface VersionInfo {
    commit: string;
}

export const getVersion = async (): Promise<VersionInfo> => {
    const response = await api.get('/system/version');
    return response.data;
};
